import { render, staticRenderFns } from "./proLiPxdialog.vue?vue&type=template&id=3e7dfac3&scoped=true&"
import script from "./proLiPxdialog.vue?vue&type=script&lang=js&"
export * from "./proLiPxdialog.vue?vue&type=script&lang=js&"
import style0 from "./proLiPxdialog.vue?vue&type=style&index=0&id=3e7dfac3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7dfac3",
  null
  
)

export default component.exports